import React, { useEffect, useState, useCallback } from "react";
import { Table, message } from "antd";
import { useNavigate } from "react-router-dom";
import Instance from "../../AxiosConfig";
import { Form } from "react-bootstrap";
import debounce from "lodash.debounce";
import "./company.css";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
const DashBoardTable = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);

  const itemsPerPage = 50;
  const token = localStorage.getItem("token");

  // ✅ API Call
  const fetchCompanies = async (page = 1, searchText = "") => {
    setLoading(true);
    try {
      const res = await Instance.get("/company", {
        params: {
          page,
          limit: itemsPerPage,
          search: searchText,
           sortBy: "createdAt",
          sortOrder: "desc",
        },
      });
      console.log("API Response:", res.data); // Debug log

      const { companies = [], total = 0 } = res.data;

      const formatted = companies.map((item, index) => ({
        key: item._id,
        slno: (page - 1) * itemsPerPage + index + 1,
        companyName: item.companyName,
        invoiceCount: item.invoiceCount || 0,
        ndaRequired: item.ndaRequired,
        slaRequired: item.slaRequired,
        proposalRequired: item.proposalRequired,
      }));

      setData(formatted);
      setTotal(total);
    } catch (err) {
      console.error(err);
      message.error("Failed to load companies");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Initial + Page Change
  useEffect(() => {
    fetchCompanies(currentPage, search);
  }, [currentPage]);

  // ✅ Debounced Search (IMPORTANT)
  const debouncedSearch = useCallback(
    debounce((value) => {
      fetchCompanies(1, value);
    }, 500),
    [],
  );

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
    setCurrentPage(1);
    debouncedSearch(value);
  };

  // ✅ Clear Search
  const handleClear = () => {
    setSearch("");
    setCurrentPage(1);
    fetchCompanies(1, "");
  };

  // ✅ Pagination Change
  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
  };

  // ✅ Columns
  const columns = [
    {
      title: "SL No",
      dataIndex: "slno",
      width: "10%",
    },
    {
      title: "Company Name",
      dataIndex: "companyName",
    },
    {
      title: "NDA",
      dataIndex: "ndaRequired",
      render: (val) =>
        val ? (
          <b>
            <CloseCircleOutlined style={{ color: "red" }} />
          </b>
        ) : (
          <b>
            <CheckCircleOutlined style={{ color: "green" }} />
          </b>
        ),
    },
    {
      title: "SLA",
      dataIndex: "slaRequired",
      render: (val) =>
        val ? (
         <b>
            <CloseCircleOutlined style={{ color: "red" }} />
          </b>
        ) : (
         <b>
            <CheckCircleOutlined style={{ color: "green" }} />
          </b>
        ),
    },
    {
      title: "Proposal",
      dataIndex: "proposalRequired",
      render: (val) =>
        val ? (
         <b>
            <CloseCircleOutlined style={{ color: "red" }} />
          </b>
        ) : (
         <b>
            <CheckCircleOutlined style={{ color: "green" }} />
          </b>
        ),
    },
    {
      title: "Invoice Count",
      dataIndex: "invoiceCount",
      render: (val) => <b>{val}</b>,
    },
  ];

  return (
    <>
      {/* 🔍 Search */}
      <div className="filter-card p-3">
        <Form>
          <div className="row g-3">
            <div className="col-md-4">
              <Form.Group>
                <Form.Label>Search Company</Form.Label>
                <Form.Control
                  type="text"
                  value={search}
                  onChange={handleSearch}
                  placeholder="Search company name..."
                />
              </Form.Group>
            </div>

            <div className="col-md-2 d-flex align-items-end">
              <button
                className="btn btn-secondary w-100"
                type="button"
                onClick={handleClear}
              >
                Clear
              </button>
            </div>
          </div>
        </Form>
      </div>

      {/* 📊 Table */}
      <div className="dashboard mt-4">
        <h2>Companies List</h2>

        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={{
            current: currentPage,
            pageSize: itemsPerPage,
            total: total,
            showSizeChanger: false,
          }}
          onChange={handleTableChange}
          rowClassName={() => "custom-row"}
          onRow={(record) => ({
            onClick: () => navigate(`/company-details/${record.key}`),
          })}
        />
      </div>
    </>
  );
};

export default DashBoardTable;
